import { render, staticRenderFns } from "./indexButtons.vue?vue&type=template&id=3ddff508"
import script from "./indexButtons.vue?vue&type=script&lang=js"
export * from "./indexButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports